export class VisitHistorySelection {

    dateFrom: string;
    dateUntil: string;
    query: string;

    constructor(selection?: any) {
        if (selection != null) {
            this.dateFrom = selection.dateFrom;
            this.dateUntil = selection.dateUntil;
            this.query = selection.query;
        }
    }

}

export class VisitHistory {

    createdAt: string;
    dayOfWeek: string;
    company: string;
    name: string;
    arrivedAt: string;
    allDay: boolean = false;
    visitedPerson: string;
    instructionsDone: boolean = false;
    instructionFinishDate: string;
    entranceAllowedWithoutGuide: boolean = false;
    phone: string;
    entranceAllowedByCar: boolean = false;
    numberPlate: string;
    chip: boolean = false;
    chipNumber: string;
    terminalRegistrationDate: string;
    accessDate: string;
    leaveDate: string;
    accessGuidedBy: string;
    leaveGuidedBy: string;

    constructor(visitHistory?: any) {
        if (visitHistory != null) {
            this.createdAt = visitHistory.createdAt;
            this.dayOfWeek = visitHistory.dayOfWeek;
            this.company = visitHistory.company;
            this.name = visitHistory.name;
            this.arrivedAt = visitHistory.arrivedAt;
            this.allDay = visitHistory.allDay;
            this.visitedPerson = visitHistory.visitedPerson;
            this.instructionsDone = visitHistory.instructionsDone;
            this.instructionFinishDate = visitHistory.instructionFinishDate;
            this.entranceAllowedWithoutGuide = visitHistory.entranceAllowedWithoutGuide;
            this.phone = visitHistory.phone;
            this.entranceAllowedByCar = visitHistory.entranceAllowedByCar;
            this.numberPlate = visitHistory.numberPlate;
            this.chip = visitHistory.chip;
            this.chipNumber = visitHistory.chipNumber;
            this.terminalRegistrationDate = visitHistory.terminalRegistrationDate;
            this.accessDate = visitHistory.accessDate;
            this.leaveDate = visitHistory.leaveDate;
            this.accessGuidedBy = visitHistory.accessGuidedBy;
            this.leaveGuidedBy = visitHistory.leaveGuidedBy;
        }

    }
}